export default function instantiateBubble(point: XY): TBubbleState {
	return {
		id: "circle_" + point[0] + "_" + point[1],
		center: point,
		isOpen: false,
		isDisabled: false,
		radius: 0,
	};
}
